import { axiosInstance } from "../../../axios/axiosInstance";
const SIGN_UP_URL = `auth/register`;

const VERIFY_PHONE_OTP = `auth/verify-phone`;
const VERIFY_EMAIL_OTP = `auth/verify-email`;
const RESEND_VERIFY_PHONE_OTP = `auth/resend-verify-phone`;
const RESEND_VERIFY_EMAIL_OTP = `auth/resend-verify-email`;
const SET_NEW_PASSWORD = `auth/set-new-password`;

const GET_USER_PROFILE = `auth/get-profile`;

const SET_UP_NEW_PROFILE = `auth/organization_signup`;
const UPDATE_PROVIDER_PROFILE = `organization/profile/update-profile`;

const UPDATE_BANK_DETAILS = `organization/profile/update-payout-details`;
const UPDATE_STAFF_PROFILE = `v1/staff/update-staff-profile`;

const IMAGE_UPLOAD = `files/upload-image`;
const DOCUMENT_UPLOAD = `files/upload-document`;
const ALL_UPLOAD = `files/upload`;

const FORGOT_PASSWORD = `auth/forgot-password`;
const VERIFY_FORGOT_PASSWORD = `auth/verify-email`;
const RESET_PASSWORD = `auth/reset-password`;
const LOGIN = `auth/login`;

//location urls
const GET_COUNTRIES_URL = "countries/get-all-countries";
const GET_STATE_URL = `countries/get-state-by-country`;
const GET_CITIES_BY_STATE_URL = `countries/get-cities-by-state`;

const SAVE_FCM = `auth/save_fcm_token`;

// register flow -> api
export const register = (registerBody) => {
  const lang = localStorage.getItem("i18nextLng");
  return axiosInstance.post(
    `${SIGN_UP_URL}?locale=${lang || "en"}`,
    registerBody
  );
};

export const verifyPhoneOtp = (otpBody) => {
  return axiosInstance.post(VERIFY_PHONE_OTP, otpBody);
};

export const verifyEmailOtp = (otpBody) => {
  return axiosInstance.post(VERIFY_EMAIL_OTP, otpBody);
};

export const resendVerifyEmailOtp = (resendBody) => {
  return axiosInstance.post(RESEND_VERIFY_EMAIL_OTP, resendBody);
};

export const resendVerifyPhoneOtp = (resendBody) => {
  return axiosInstance.post(RESEND_VERIFY_PHONE_OTP, resendBody);
};

export const setNewPassword = (setPasswordBody) => {
  return axiosInstance.patch(SET_NEW_PASSWORD, setPasswordBody);
};

export const setupNewProfile = (profileBody) => {
  return axiosInstance.post(SET_UP_NEW_PROFILE, profileBody);
};

export const getUserProfile = () => {
  return axiosInstance.get(GET_USER_PROFILE);
};

export const updateProviderProfile = (profileBody) => {
  return axiosInstance.post(UPDATE_PROVIDER_PROFILE, profileBody);
};

export const updateBankDetails = (dataToBeSent) => {
  return axiosInstance.post(UPDATE_BANK_DETAILS, dataToBeSent);
};

export const updateStaffProfile = (profileBody) => {
  return axiosInstance.post(UPDATE_STAFF_PROFILE, profileBody);
};

// country, state, city
export const getAllCountry = () => {
  return axiosInstance.get(GET_COUNTRIES_URL);
};
export const getStateByCountry = (stateObject) => {
  return axiosInstance.post(GET_STATE_URL, stateObject);
};
export const getCityByState = (cityBody) => {
  return axiosInstance.post(GET_CITIES_BY_STATE_URL, cityBody);
};

// login flow -> api
export const providerLogin = (loginBody) => {
  return axiosInstance.post(LOGIN, loginBody);
};

export const forgotPassword = (forgotPasswordBody) => {
  return axiosInstance.post(FORGOT_PASSWORD, forgotPasswordBody);
};

export const verifyForgotPassword = (forgotPasswordBody) => {
  return axiosInstance.post(VERIFY_FORGOT_PASSWORD, forgotPasswordBody);
};

export const resetNewPassword = (resetPasswordBody) => {
  return axiosInstance.put(RESET_PASSWORD, resetPasswordBody);
};

export const fileImageUpload = (formDataBody) => {
  return axiosInstance.post(IMAGE_UPLOAD, formDataBody, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const fileDocumentUpload = (formDataBody) => {
  return axiosInstance.post(DOCUMENT_UPLOAD, formDataBody, {
    headers: {
      Authorization: localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    },
  });
};

export const fileUpload = (formDataBody) => {
  return axiosInstance.post(ALL_UPLOAD, formDataBody, {
    headers: {
      Authorization: localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    },
  });
};

export const saveFCM = async (requestData) => {
  return axiosInstance.post(SAVE_FCM, requestData);
};
